import {Injectable} from '@angular/core';
import {RequestService} from "@services/request.service";

@Injectable({
  providedIn: 'root'
})
export class PaymentService {
  apiPrefix = '';

  constructor(
    private requestService: RequestService
  ) {
    this.apiPrefix = '/v1/payment-intent/'
  }

  createPaymentIntent(params, token) {
    return this.requestService.post(this.apiPrefix + 'create', params, 'bms', token);
  }

  updatePaymentIntent(params, token) {
    return this.requestService.post(this.apiPrefix + 'update', params, 'bms', token);
  }

}
